import { render, staticRenderFns } from "./RegisterPayment.vue?vue&type=template&id=3cd42b5d&scoped=true&"
import script from "./RegisterPayment.vue?vue&type=script&lang=js&"
export * from "./RegisterPayment.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPayment.vue?vue&type=style&index=0&id=3cd42b5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd42b5d",
  null
  
)

export default component.exports